import { ajaxT } from 'util'

/**
 * 获取班车站点集合（一字排开页面）
 */

export function getBcStationList(params) {
  return ajaxT.post('manage/getBcStationList', params)
}
/**
 * 获取班车经纬度点集合
 */

export function getLineGps(params) {
  return ajaxT.post('manage/getLineGps', params)
}

/**
 * 获取实时运行班车列表
 */

export function getRunBus(params) {
  return ajaxT.post('manage/getRunBus', params)
}
